import {
  COUPON_SEARCH,
  COUPON_RESET_SEARCH,
  COUPON_COUNT_TOTAL,
    COUPON_LIST_FETCH_SUCCESS,
    COUPON_DETAIL_FETCH_SUCCESS,
    COUPON_DETAIL_CLEAR,
} from "../actions/types";

const INIT_STATE = {
  search:{
    searchVal:"",
    page:1,
    perPage:100,
  },
  countTotal: 0,
    list: [],
    detail: {},
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
    case COUPON_SEARCH:{
      return {
        ...state,
        search: action.payload
      };
    }
    case COUPON_RESET_SEARCH:{
      return {
        ...state,
        search:{
          searchVal:"",
          page:1,
          perPage:100,
        }
      }
    }
    case COUPON_COUNT_TOTAL:{
      return {
        ...state,
        countTotal:action.payload,
      }
    }
        case COUPON_LIST_FETCH_SUCCESS: {
            return {
                ...state,
                list: action.payload,
            };
        }
        case COUPON_DETAIL_CLEAR: {
            return {
                ...state,
                detail: {}
            }
        }
        case COUPON_DETAIL_FETCH_SUCCESS: {
            return {
                ...state,
                detail: action.payload
            };
        }
        default:
            return state;
    }
};
